/**
 * 应用管理
 * zxw
 * 创建时间 2026-02-05
 */

import CNF from "../../incs/Config";
import {
    winHeight,
    AddRequestHeaders,
    UjoinParams,
    CopyToClipboard,
    rootReactDom,
    ShowIPModal,
} from "../../incs/FunHelper";
import { WorkFlowIcon, } from '../../incs/Icons';

import { useState, useEffect } from "react";
import $ from 'jquery';
import {
    Row,
    Col,
    Segmented,
    Input,
    Flex,
    theme,
    Button,
    Space,
    Avatar,
    Card,
    Typography,
    message,
    Badge,
    Dropdown,
} from 'antd';
import {
    SearchOutlined,
    PlusOutlined,
    CopyOutlined,
    CheckOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';

import AppUpdateEntity from '../appTemplate/AppUpdateEntity';


const { Text, Title } = Typography;

const MODULENAME = '应用';
const MODULENAME_URL = '/app/infos';

const AppManagement = (props) => {
    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorBgSolid,
            colorTextBase,
            colorSuccessActive,
            colorBgContent,
            colorBasePlaceholder,
            fontSizeLG,
            fontSizeSM,
        },
    } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(false);
    const [copyOk, setCopyOk] = useState(false);
    const [dataLists, setDataLists] = useState([]); // 应用列表
    const [appName, setAppName] = useState('');     // 应用名称
    const [appType, setAppType] = useState('');     // 应用类型


    const [hoverIndex, setHoverIndex] = useState(-1);

    const setRefresh = () => {
        setIsRefresh(!isRefresh);
    }


    /**
     * 渲染修改应用信息
     * @returns 
     */
    const renderAppUpdateEnity = (record) => {
        rootReactDom && rootReactDom.render(
            <AppUpdateEntity open={true} setRefresh={setRefresh} record={record} />
        );
    }

    /**
     * 获取列表
     */
    useEffect(() => {
        const getLists = () => {
            const params = {
                'app_name': appName,
                'app_type': appType,
                'page_size': CNF.pageSize,
            };
            $.ajax({
                url: `${CNF.api}${MODULENAME_URL.slice(1,)}${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setDataLists(data.dat);
                        } else {
                            setDataLists([]);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
        }
        getLists();
    }, [isRefresh, messageApi, appName, appType]);


    return <>
        {contextHolder}
        {/* --start-- 标题栏 */}
        <div style={{
            height: CNF.contentHeaderHeight,
            borderBottom: 'solid 1px',
            borderBottomColor: colorBgSolid,
            padding: `0 ${CNF.basePadding}px`,
        }}>
            <Row style={{
                height: CNF.contentHeaderHeight,
                display: 'flex',
                alignItems: 'center',
            }}>
                <Col span={8}>
                    <Text style={{ color: colorTextBase, fontSize: fontSizeLG }} strong>{props.menuName}</Text>
                </Col>
                <Col span={8} style={{ textAlign: 'center' }}>
                    <Segmented
                        options={['全部', '工作流']}
                        style={{
                            color: colorTextBase,
                        }}
                        onChange={value => {
                            setAppType(value === '全部' ? '' : value);
                        }}
                    />
                </Col>
                <Col span={8} style={{ textAlign: 'right' }}>
                    <Space>
                        <Button
                            style={{ width: '100%' }}
                            color='primary'
                            variant={props.isDarkMode ? 'filled' : 'solid'}
                            onClick={() => {
                                props.renderAppCreateEnity(setRefresh);
                            }}
                        >
                            <Space><PlusOutlined />创建应用</Space>
                        </Button>
                    </Space>
                </Col>
            </Row>
        </div>
        {/* --end-- 标题栏 */}

        {/* 卡片栏 */}
        <div style={{
            padding: CNF.basePadding,
            paddingBottom: 0,
            height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 9,
            scrollbarColor: '#d9d9d9 transparent',
            scrollbarWidth: 'thin',
            overflowY: 'auto',
        }}>
            <Space vertical size={CNF.basePadding}>
                <Input
                    placeholder='搜索应用名称'
                    prefix={<SearchOutlined style={{ color: colorBasePlaceholder }} />}
                    style={{ width: 240, backgroundColor: colorBgContent, color: colorTextBase, }}
                    value={appName}
                    onChange={(e) => {
                        setAppName(e.target.value);
                    }}
                />
                <Flex wrap gap={CNF.basePadding} style={{
                    marginBottom: CNF.basePadding,
                    boxSize: 'border-box',
                }}>
                    {
                        dataLists.map((item, index) => {
                            const items = [
                                {
                                    key: '1',
                                    label: <Button color='default' variant='link' icon={<EditOutlined />} style={{ color: colorTextBase, padding: 0 }} onClick={(e) => {
                                        e.stopPropagation();
                                        renderAppUpdateEnity(item);
                                    }}>修改信息</Button>
                                },
                                {
                                    key: '2',
                                    label: <Button color='default' variant='link' icon={<CopyOutlined />} style={{ color: colorTextBase, padding: 0 }}>复制应用</Button>
                                },
                                {
                                    key: '3',
                                    label: <Button color='default' variant='link' icon={<DeleteOutlined />} style={{ color: colorTextBase, padding: 0 }} onClick={(e) => {
                                        e.stopPropagation();
                                        const uri = MODULENAME_URL.slice(1,) + '/' + item.key;
                                        ShowIPModal(item.app_name, CNF.actionName.DELETE, MODULENAME, setIsRefresh, uri);
                                    }}>删除应用</Button>
                                }
                            ]
                            return <Card
                                key={index}
                                hoverable={true}
                                loading={false}
                                style={{
                                    height: 164,
                                    width: `calc(20% - ${CNF.basePadding * 4 / 5}px)`,
                                    maxWidth: '480px',
                                    minWidth: '280px',
                                    cursor: 'pointer',
                                }}
                                styles={{
                                    root: {
                                        border: `1px solid ${hoverIndex === index ? colorPrimary : colorBgSolid}`,
                                    },
                                }}
                                onClick={(e) => {
                                    if (['DIV', 'H5', 'IMG'].includes(e.target.tagName)) {
                                        if (item.is_release) {
                                            // 进入应用运行界面
                                            props.setUri(props.appRunUri + item.app_id);
                                        } else {
                                            // 进入应用发布界面
                                            props.setUri(props.uri + '/appWorkFlow/' + item.app_id);
                                        }
                                    }
                                }}
                                onMouseEnter={() => { setHoverIndex(index); }}
                                onMouseLeave={() => { setHoverIndex(-1); }}
                            >
                                <Flex gap='small' style={{ color: colorTextBase, alignItems: 'center', }}>
                                    <div style={{ width: 32, }}>
                                        {
                                            item.app_icon ? <Avatar shape='square' src={item.app_icon} />
                                                :
                                                <Avatar shape='square' style={{ background: colorPrimaryBg }}><WorkFlowIcon style={{ fontSize: fontSizeLG + 4, color: colorPrimary, }} /></Avatar>
                                        }
                                    </div>
                                    <Title
                                        style={{ margin: 0, width: '100%', }}
                                        level={5}
                                        ellipsis
                                    >
                                        {item.app_name}
                                    </Title>
                                    <div style={{ maxWidth: 60, minWidth: 60, textAlign: 'right' }}>
                                        <Badge status={item.is_release ? 'success' : 'default'} text={item.is_release ? CNF.releaseStatus.DONE : CNF.releaseStatus.NOT} />
                                    </div>
                                </Flex>
                                <Flex gap='small' style={{ color: colorTextBase, alignItems: 'center', marginTop: CNF.basePadding / 2, }}>
                                    <Text style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, minWidth: 36, maxWidth: 60, }}>应用ID</Text>
                                    <Text ellipsis style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, }}>
                                        {item.app_id}
                                    </Text>
                                    <Button
                                        color='default'
                                        variant='text'
                                        size='small'
                                        icon={hoverIndex === index ? (copyOk ? <CheckOutlined style={{ color: colorSuccessActive }} /> : <CopyOutlined />) : ''}
                                        style={{ margin: 0 }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (copyOk) return;
                                            CopyToClipboard(item.app_id);
                                            setCopyOk(true);
                                            setTimeout(() => {
                                                setCopyOk(false);
                                            }, CNF.messageDuration * 2000);
                                        }}
                                    />
                                </Flex>
                                <div style={{ marginTop: 22, }}>
                                    {
                                        hoverIndex === index ?
                                            <Flex gap={CNF.basePadding / 2}>
                                                <Button
                                                    color='primary'
                                                    variant={props.isDarkMode ? 'filled' : 'solid'}
                                                    style={{ width: '50%', }}
                                                    onClick={() => {
                                                        props.setUri(CNF.menuItems[0].submenu[1].uri + '/appWorkFlow/' + item.app_id);
                                                    }}>配置</Button>
                                                <Dropdown
                                                    menu={{ items }}
                                                    placement='bottomLeft'
                                                >
                                                    <Button
                                                        color='default'
                                                        variant='filled'
                                                        style={{ width: '50%', }}>更多</Button>
                                                </Dropdown>
                                            </Flex>
                                            :
                                            <Space>
                                                {/* 更新时间 */}
                                                <Text style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, }}>更新时间</Text>
                                                <Text ellipsis style={{ color: CNF.basePlaceholderColor, fontSize: fontSizeSM, }}>
                                                    {item.update_time}
                                                </Text>
                                            </Space>
                                    }
                                </div>
                            </Card>
                        })
                    }
                </Flex>
            </Space>
        </div >
        {/* 卡片栏 */}
    </>
}

export default AppManagement;